import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store';
import { useOrgStore } from '../store/org';
import { isOrgAdmin, hasModule } from '../auth/capabilities';
import { vpApi } from '../api/velopulse';

/** 「設定」與手機「更多」共用：組織、既有表單／CRM／LINE 管理功能的入口 */
export default function SettingsHubPage({ more = false }) {
  const { user, hasPermission, logout } = useAuthStore();
  const { currentOrg, clearOrg } = useOrgStore();
  const navigate = useNavigate();
  const role = user?.role;
  const isAdmin = ['super_admin', 'dept_admin'].includes(role);
  const canOrgAdmin = isOrgAdmin(currentOrg);
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    vpApi.getPlatformMe()
      .then((data) => { if (!cancelled) setIsPlatformAdmin(Boolean(data?.is_platform_admin)); })
      .catch(() => { if (!cancelled) setIsPlatformAdmin(false); });
    return () => { cancelled = true; };
  }, [user?.id]);

  const showAutomotive = hasModule(currentOrg, 'automotive');
  const showRealty = hasModule(currentOrg, 'real_estate');

  const groups = [
    { title: '賣房工具', items: [
      { to: '/realty/tax', label: '稅試算', desc: '房地合一 2.0', show: showRealty },
      { to: '/realty/title-deed', label: '調謄本', desc: '土地／建物謄本查詢', show: showRealty },
      { to: '/realty/search', label: '搜房', desc: '示範物件', show: showRealty },
    ] },
    { title: '賣車工具', items: [
      { to: '/auto/plates', label: '號牌查詢', desc: '監理站示範／降級', show: showAutomotive },
    ] },
    { title: '組織', items: [
      { to: '/orgs', label: '切換組織', desc: currentOrg ? `目前：${currentOrg.name}` : '尚未選擇組織', show: true },
      { to: '/org-admin', label: '公司管理', desc: '本公司成員與設定', show: canOrgAdmin },
      { to: '/platform', label: '平台管理', desc: '開公司、開通賣房／賣車、管理公司使用者', show: isPlatformAdmin },
      { to: '/departments', label: '部門', show: role === 'super_admin' },
    ] },
    { title: '表單與名單', items: [
      { to: '/forms', label: '表單總覽', show: true },
      { to: '/submissions', label: '提交記錄', show: true },
      { to: '/builder/new', label: '新增表單', show: isAdmin },
      { to: '/pipeline', label: '業務管線（表單名單）', show: ['super_admin', 'dept_admin', 'manager'].includes(role) },
      { to: '/my-deals', label: '我的商機（表單名單）', show: role === 'staff' },
      { to: '/contacts', label: '名片王', show: showAutomotive && hasPermission('contacts_manage') },
    ] },
    { title: '管道與整合', items: [
      { to: '/channels/line/wizard', label: 'LINE Bot 設定精靈', show: true },
      { to: '/linebot', label: 'LINE Bot 管理與訊息', show: hasPermission('linebot_manage') },
      { to: '/calendar', label: '行事曆', show: hasPermission('calendar_manage') },
      { to: '/knowledge', label: '知識庫', show: hasPermission('knowledge_manage') },
      { to: '/crm/connections', label: 'CRM 連線', show: hasPermission('crm_connections') },
      { to: '/crm/mapping', label: 'CRM 欄位對應', show: hasPermission('crm_mapping') },
      { to: '/crm/jobs', label: 'CRM 任務監控', show: hasPermission('crm_jobs') },
    ] },
  ];

  return (
    <div className="vp-content" style={{ maxWidth: 760 }}>
      {more && (
        <div className="vp-card vp-more" style={{ marginBottom: 12 }}>
          <Link to="/assistant">✦ 萬事通</Link>
          {showAutomotive && <Link to="/records">紀錄</Link>}
        </div>
      )}
      {groups.map((g) => {
        const items = g.items.filter((i) => i.show);
        if (!items.length) return null;
        return (
          <div className="vp-card vp-more" key={g.title} style={{ marginBottom: 12 }}>
            <h2>{g.title}</h2>
            {items.map((i) => (
              <Link key={i.to} to={i.to}>{i.label}{i.desc && <span className="vp-muted" style={{ fontSize: 12 }}>　{i.desc}</span>}</Link>
            ))}
          </div>
        );
      })}
      <button type="button" className="vp-btn" onClick={() => { clearOrg(); logout(); navigate('/login'); }}>登出（{user?.name || '使用者'}）</button>
    </div>
  );
}
